import loginReducer from "./login.reducer";
import supplierReducer from "./supplier.reducer";
import factoryReducer from "./factory.reducer";
import navigationReducer from "./navigation.reducer";
import auditReducer from "./audit.reducer";
import miscReducer from "./misc.reducer";
import riskReducer from "./risk.reducer";
import analyticsReducer from "./analytics.reducer";
import collaborativeFormReducer from "./collaborativeForm.reducer";
import formReducer from "./form.reducer";
import wipReducer from "./wip.reducer";
import wipNotificationReducer from "./wipNotification.reducer";
import notificationReducer from "./notification.reducer";

const rootReducer = {
  login: loginReducer,
  supplier: supplierReducer,
  factory: factoryReducer,
  navigation: navigationReducer,
  audit: auditReducer,
  misc: miscReducer,
  risk: riskReducer,
  analytics: analyticsReducer,
  collaborativeForm: collaborativeFormReducer,
  form: formReducer,
  wip: wipReducer,
  wipNotification: wipNotificationReducer,
  notification: notificationReducer,
};

export default rootReducer;
